import { SET_REVIEWS } from '../actions/types';

export default function ratings(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_REVIEWS:
				return action.payload;
			// no default
		}
	}

	return state;
}
